; (function ($) {

    let recipeNavSlideOptions = {
        infinite: true,
        slidesToShow: 1,
        altText: 'nav',
        prevArrow: '#recipe-prev',
        nextArrow: '#recipe-next',
        asNavFor: '.recipes-banner-slider-image',
        dots: false,
        fade:true,
    }

    let recipeSlideOptions = {
        infinite: true,
        slidesToShow: 1,
        dots: false,
        arrows: false,
        asNavFor: '.recipes-banner-slider-text',
    }

    $(document).ready(function () {
        $('.recipes-banner-slider-text').slick(recipeNavSlideOptions);
        $('.recipes-banner-slider-image').slick(recipeSlideOptions);

        $('#recipe-next').on('click', () => {
            console.log('clicked');
        });

        $('#recipe-next').attr('alt', 'naviatgation arrows');
        $('#recipe-prev').attr('alt', 'naviatgation arrows');


        if ($(window).width() < 1025) {
	        $('.question-popup').on('click', function(e){
	        	$(this).find('.popup-message').toggle();
	        });
    	}
    	if ($(window).width() > 1024) {
	        $('.question-popup').on('hover', function(e){
	        	$(this).find('.popup-message').toggle();
	        });

            $('.share-section').bind('mouseenter mouseleave', function(e){
                $('.open-share').toggleClass('hide');
                $('.share-links').toggle();
            });
    	}

    });

  })(jQuery);
